import {
    HttpResponse,
    ProjectModel,
    RequestParams,
    ApiResultFailed,
    Operation,
    AggregationModel,
    AggregationResponse,
    GrouppedQueryModel
} from "@/libs/Api";
import ApiService from "@/libs/core/api-service"
import {CrudDataQuery, CrudService} from '@/libs/core/+state/models/crud-service';
import {CrudEnumerableResponse, CrudResponse} from "../core/+state/models/crud-response";

export class ProjectsDataService implements CrudService<ProjectModel, ProjectModel> {
    getAll(query: CrudDataQuery<ProjectModel>): Promise<CrudEnumerableResponse<ProjectModel>> {
        return ApiService.api.getProjectBatch(query.pageIndex, query.pageSize, <any>query.data, query.params);
    }

    getBasicAll(query: CrudDataQuery<ProjectModel>): Promise<CrudEnumerableResponse<ProjectModel>> {
        throw new Error('NotImplemented');
    }

    get(id: string, params?: RequestParams): Promise<CrudResponse<ProjectModel>> {
        return ApiService.api.getProjectById(id, params);
    }

    create(item: ProjectModel, params?: RequestParams): Promise<CrudResponse<ProjectModel>> {
        return ApiService.api.insertProject(item, params);
    }

    update(item: ProjectModel, params?: RequestParams): Promise<ProjectModel> {
        return ApiService.api.updateProject(item.id as Required<string>, item, params).then((req: any) => req.data.returnValue);
    }

    partialUpdate(id: string, patches: Operation[], params?: RequestParams): Promise<ProjectModel> {
        return ApiService.api.patchProject(id, patches, params).then((req: any) => req.data.returnValue);
    }

    delete(query: CrudDataQuery<ProjectModel>): Promise<CrudEnumerableResponse<ProjectModel>> {
        return ApiService.api.deleteProjects(<any>query.data, query.params).then((req: any) => req.data.returnValue);
    }

    getAggregation(query: AggregationModel, params?: RequestParams): Promise<AggregationResponse> {
        return ApiService.api.aggregationProject(query, params).then((req: any) => req.data.returnValue);
    }
    
    download(query: CrudDataQuery<ProjectModel>): Promise<HttpResponse<any, ApiResultFailed | void>> {
        throw new Error('NotImplemented');
    }

    clone(item: ProjectModel, params?: RequestParams): Promise<CrudResponse<ProjectModel>> {
        throw new Error('NotImplemented');
    }

    getGroupped(query: GrouppedQueryModel, params?: RequestParams): Promise<CrudResponse<any>> {
        return ApiService.api.getProjectGroupped(query, params);
    }

}
